import types from './types';

import people from '../data/people';

const initialState = {
  jobs: undefined,
  quotes: [
    {
      ...(people.find(({ key }) => key === 'kyleb')),
      quote: 'You’ll be challenged and motivated on a daily basis. You’ll foster meaningful relationships and be rewarded for your contributions. At RealtyMogul, how we work together is as important as the work we accomplish.',
    },
    {
      ...(people.find(({ key }) => key === 'christinal')),
      quote: 'A company is only as extraordinary as its people. That cannot be more true than at RealtyMogul. RealtyMogul is truly a people oriented organization, where collaboration and support for one another spans beyond work and creates a truly thriving team culture.',
    },
    {
      ...(people.find(({ key }) => key === 'jasonc')),
      quote: 'RealtyMogul has done a great job creating an environment of teamwork, collaboration and excellence. Individuals are valued for who they are and how they contribute to the overall vision. Everyone\'s voice is heard and appreciated. This is a company that really gets it.',
    },
    {
      ...(people.find(({ key }) => key === 'aubreyo')),
      quote: 'Every person on the RealtyMogul team brings a different set of professional skills and personality to the team, creating a well-rounded and positive organization.',
    },
    {
      ...(people.find(({ key }) => key === 'marcoa')),
      quote: 'I love working at RealtyMogul. I enjoy the challenging, fast-paced environment and working alongside so many talented and passionate people. I know my work makes an impact and I feel valued for what I do.',
    },
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CAREER_LIST_SUCCEEDED: {
      return {
        ...state,
        jobs: action.data.departments.reduce((jobs, department) => ([
          ...jobs,
          ...department.jobs.map((job) => ({
            title: job.title,
            location: job.location.name,
            department: department.name,
            url: job.absolute_url,
          })),
        ]), []),
      };
    }
    default:
      return {
        ...state,
      };
  }
};
